import { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { isEqual } from 'lodash';
import dayjs from 'dayjs';
import Yup from '../../utils/yup';
import utc from 'dayjs/plugin/utc';
import { useParams } from 'react-router-dom';

import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';
import useUsers from '../../context/UsersContext';
import { getDynVals } from '../../utils/DynHelper';
import propertyService from '../../service/property.service';
import { ConfirmDialogUI, DeleteDialogUI, FormButtonPanelUI, FormHeaderUI } from '../Interface';
import { EmployeeFields } from './EmployeeFields';
import History from '../History/History';
import HistoryDialog from '../History/HistoryDialog';
import { JokerFieldTypes, JokerTypes } from '../../config/joker';
import jokerService from '../../service/joker.service';
import { cleanValues, getJokerFieldType } from '../../utils/helper';
import employeeService from '../../service/employee.service';
import EmployeeTabs from './EmployeeTabs';
import EmployeePriceDialog from './EmployeePriceDialog';

export const EmployeePage = ({ employeeState, dialog }) => {
  const {
    setRefetchTable,
    selectedValues,
    setSelectedValues,
    viewField,
    setViewField,
    operatorsDisabled,
    setOperatorsDisabled,
    submenu,
    canEdit,
    dynProps,
    setDynProps,
    autocompleteOptions,
    dynLoading,
    setDynLoading,
    autocompleteData,
    jokerLoading,
    jokerFields,
    jokerLineFields,
  } = employeeState;
  const { id } = useParams();
  const { getUser, user } = useUsers();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [matchedData, setMatchedData] = useState({});
  const [editButtonVisible, setEditButtonvisible] = useState(true);
  const [addField, setAddField] = useState(true);

  const [defaultValues, setDefaultValues] = useState({});
  const [initValues, setInitValues] = useState({});
  const [defaultSelectedValues, setDefaultSelectedValues] = useState({});
  const [propertyGroups, setPropertyGroups] = useState([]);
  const [group, setGroup] = useState({
    id: [],
  });
  const [priceDialogOpen, setPriceDialogOpen] = useState(false);

  const defaultCommunication = {
    id: null,
    isNew: true,
    message: '',
    userId: user.userId,
    userName: user.userName,
    createdAt: null,
    calendarVisibleOn: null,
  };

  const defEmployeeLine = {
    joker_char1: '',
    joker_char2: '',
    joker_char3: '',
    joker_char4: '',
    joker_char5: '',
    joker_char6: '',
    joker_char7: '',
    joker_char8: '',
    joker_char9: '',
    joker_char10: '',
    joker_date1: null,
    joker_date2: null,
    joker_date3: null,
    joker_date4: null,
    joker_date5: null,
    joker_num1: '',
    joker_num2: '',
    joker_num3: '',
    joker_num4: '',
    joker_num5: '',
    joker_num6: '',
    joker_num7: '',
    joker_num8: '',
    joker_num9: '',
    joker_num10: '',
    joker_num11: '',
    joker_num12: '',
    joker_num13: '',
    joker_num14: '',
    joker_num15: '',
    joker_int1: '',
    joker_int2: '',
    joker_int3: '',
    joker_int4: '',
    joker_int5: '',
    description: '',
  };

  const def = {
    name: '',
    groupId: null,
    active: true,
    statusId: null,
    typeId: null,
    classificationId: null,
    costPerHour: '',
    class1: false,
    class2: false,
    class3: false,
    class4: false,
    class5: false,
    class6: false,
    class7: false,
    class8: false,
    class9: false,
    class10: false,
    class11: false,
    class12: false,
    class13: false,
    class14: false,
    class15: false,
    class16: false,
    class17: false,
    class18: false,
    class19: false,
    class20: false,
    joker_char1: '',
    joker_char2: '',
    joker_char3: '',
    joker_char4: '',
    joker_char5: '',
    joker_char6: '',
    joker_char7: '',
    joker_char8: '',
    joker_char9: '',
    joker_char10: '',
    joker_date1: null,
    joker_date2: null,
    joker_date3: null,
    joker_date4: null,
    joker_date5: null,
    joker_num1: '',
    joker_num2: '',
    joker_num3: '',
    joker_num4: '',
    joker_num5: '',
    joker_num6: '',
    joker_num7: '',
    joker_num8: '',
    joker_num9: '',
    joker_num10: '',
    joker_num11: '',
    joker_num12: '',
    joker_num13: '',
    joker_num14: '',
    joker_num15: '',
    joker_int1: '',
    joker_int2: '',
    joker_int3: '',
    joker_int4: '',
    joker_int5: '',
    communication: [],
    color: '',
    email: '',
    phoneNumber: '',
    position: '',
    specialization: '',
    price: null,
    employeeLine: [],
    fieldWorker: false,
  };
  useEffect(() => {
    if (!Object.keys(user).length) getUser();

    setDefaultValues(def);
  }, []);

  useEffect(() => {
    if (Object.keys(autocompleteData).length > 0) {
      setDefaultValues((prev) => {
        return {
          ...prev,
          statusId: autocompleteData?.status?.defaultValue ?? null,
          typeId: autocompleteData?.type?.defaultValue ?? null,
          groupId: autocompleteData?.employeeGroup?.defaultValue ?? null,
          classificationId: autocompleteData?.classification?.defaultValue ?? null,
        };
      });

      setDefaultSelectedValues((prev) => {
        return {
          ...prev,
          status: autocompleteData?.status?.defItem,
          type: autocompleteData?.type?.defItem,
          employeeGroup: autocompleteData?.employeeGroup?.defItem,
          classification: autocompleteData?.classification?.defItem,
        };
      });
    }
  }, [autocompleteData]);

  useEffect(() => {
    if (submenu) {
      getPropertyGroupsForForm();
    }
  }, [submenu]);

  useEffect(() => {
    setSelectedValues(defaultSelectedValues);
  }, [defaultSelectedValues]);

  useEffect(() => {
    if (Object.keys(selectedValues).length > 0) {
      if (!isEqual(defaultSelectedValues, selectedValues)) {
        valuesToForm();
        setOperatorsDisabled(false);
      } else {
        setOperatorsDisabled(true);
        setInitValues(defaultValues);
      }
    }
  }, [selectedValues]);

  useEffect(() => {
    if (id) {
      getEmployeeById(id);
    } else {
      setSelectedValues(defaultSelectedValues);
    }
  }, [defaultSelectedValues, id]);

  const getEmployeeById = (selectedId) => {
    employeeService.getEmployeeById(selectedId).then((data) => {
      setSelectedValues(data);
    });
  };

  const getPropertyGroupsForForm = () => {
    propertyService.getPropertyGroupsForSubmenus({ data: [submenu] }).then((data) => {
      setPropertyGroups(data);
    });
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    groupId: Yup.string().nullable(),
    active: Yup.boolean(),
    statusId: Yup.string().nullable(),
    typeId: Yup.string().nullable(),
    classificationId: Yup.string().nullable(),
    costPerHour: Yup.number().positive().nullable(),
    class1: Yup.boolean(),
    class2: Yup.boolean(),
    class3: Yup.boolean(),
    class4: Yup.boolean(),
    class5: Yup.boolean(),
    class6: Yup.boolean(),
    class7: Yup.boolean(),
    class8: Yup.boolean(),
    class9: Yup.boolean(),
    class10: Yup.boolean(),
    class11: Yup.boolean(),
    class12: Yup.boolean(),
    class13: Yup.boolean(),
    class14: Yup.boolean(),
    class15: Yup.boolean(),
    class16: Yup.boolean(),
    class17: Yup.boolean(),
    class18: Yup.boolean(),
    class19: Yup.boolean(),
    class20: Yup.boolean(),
    email: Yup.string().nullable(),
    phoneNumber: Yup.string().nullable(),
    position: Yup.string().nullable(),
    specialization: Yup.string().nullable(),
    fieldWorker: Yup.boolean(),
    ...(jokerFields.length > 0
      ? Object.fromEntries(
          jokerFields.map((field) => {
            const fieldType = getJokerFieldType(field);
            return [
              field.field,
              fieldType === JokerFieldTypes.NUMBER ? Yup.number().nullable() : Yup.string().nullable(),
            ];
          })
        )
      : {}),
    communication: Yup.array().of(
      Yup.object().shape({
        message: Yup.string().required(),
        calendarVisibleOn: Yup.string().nullable(),
      })
    ),
    employeeLine: Yup.array().of(
      Yup.object().shape({
        ...(jokerLineFields.length > 0
          ? Object.fromEntries(
              jokerLineFields.map((field) => {
                const fieldType = getJokerFieldType(field);
                return [
                  field.field,
                  fieldType === JokerFieldTypes.NUMBER ? Yup.number().nullable() : Yup.string().nullable(),
                ];
              })
            )
          : {}),
        description: Yup.string().nullable(),
      })
    ),
  });

  const valuesToForm = () => {
    const {
      id,
      name,
      groupId,
      active,
      statusId,
      typeId,
      classificationId,
      employeeCommunication,
      costPerHour,
      class1,
      class2,
      class3,
      class4,
      class5,
      class6,
      class7,
      class8,
      class9,
      class10,
      class11,
      class12,
      class13,
      class14,
      class15,
      class16,
      class17,
      class18,
      class19,
      class20,
      joker_char1,
      joker_char2,
      joker_char3,
      joker_char4,
      joker_char5,
      joker_char6,
      joker_char7,
      joker_char8,
      joker_char9,
      joker_char10,
      joker_date1,
      joker_date2,
      joker_date3,
      joker_date4,
      joker_date5,
      joker_num1,
      joker_num2,
      joker_num3,
      joker_num4,
      joker_num5,
      joker_num6,
      joker_num7,
      joker_num8,
      joker_num9,
      joker_num10,
      joker_num11,
      joker_num12,
      joker_num13,
      joker_num14,
      joker_num15,
      joker_int1,
      joker_int2,
      joker_int3,
      joker_int4,
      joker_int5,
      color,
      email,
      phoneNumber,
      position,
      specialization,
      employeeLine,
      fieldWorker,
    } = selectedValues;

    setInitValues({
      id,
      name,
      groupId,
      active,
      statusId,
      typeId,
      classificationId,
      costPerHour: costPerHour ?? defaultValues.costPerHour,
      class1,
      class2,
      class3,
      class4,
      class5,
      class6,
      class7,
      class8,
      class9,
      class10,
      class11,
      class12,
      class13,
      class14,
      class15,
      class16,
      class17,
      class18,
      class19,
      class20,
      joker_char1: joker_char1 ?? '',
      joker_char2: joker_char2 ?? '',
      joker_char3: joker_char3 ?? '',
      joker_char4: joker_char4 ?? '',
      joker_char5: joker_char5 ?? '',
      joker_char6: joker_char6 ?? '',
      joker_char7: joker_char7 ?? '',
      joker_char8: joker_char8 ?? '',
      joker_char9: joker_char9 ?? '',
      joker_char10: joker_char10 ?? '',
      joker_date1,
      joker_date2,
      joker_date3,
      joker_date4,
      joker_date5,
      joker_num1: joker_num1 ?? '',
      joker_num2: joker_num2 ?? '',
      joker_num3: joker_num3 ?? '',
      joker_num4: joker_num4 ?? '',
      joker_num5: joker_num5 ?? '',
      joker_num6: joker_num6 ?? '',
      joker_num7: joker_num7 ?? '',
      joker_num8: joker_num8 ?? '',
      joker_num9: joker_num9 ?? '',
      joker_num10: joker_num10 ?? '',
      joker_num11: joker_num11 ?? '',
      joker_num12: joker_num12 ?? '',
      joker_num13: joker_num13 ?? '',
      joker_num14: joker_num14 ?? '',
      joker_num15: joker_num15 ?? '',
      joker_int1: joker_int1 ?? '',
      joker_int2: joker_int2 ?? '',
      joker_int3: joker_int3 ?? '',
      joker_int4: joker_int4 ?? '',
      joker_int5: joker_int5 ?? '',
      email: email ?? defaultValues.email,
      phoneNumber: phoneNumber ?? defaultValues.phoneNumber,
      position: position ?? defaultValues.position,
      specialization: specialization ?? defaultValues.specialization,
      color: color ?? defaultValues.color,
      dynamicFields: getDynVals(dynProps, selectedValues.dynamicProperties),
      fieldWorker,
      communication: employeeCommunication?.map((rc) => ({
        id: rc.id,
        message: rc.message,
        userId: rc.user.userId,
        userName: rc.user.userName,
        createdAt: rc.createdAt,
        calendarVisibleOn: rc.calendarVisibleOn,
      })),
      employeeLine: employeeLine?.map((el) => ({
        id: el.id,
        joker_char1: el.joker_char1 ?? '',
        joker_char2: el.joker_char2 ?? '',
        joker_char3: el.joker_char3 ?? '',
        joker_char4: el.joker_char4 ?? '',
        joker_char5: el.joker_char5 ?? '',
        joker_char6: el.joker_char6 ?? '',
        joker_char7: el.joker_char7 ?? '',
        joker_char8: el.joker_char8 ?? '',
        joker_char9: el.joker_char9 ?? '',
        joker_char10: el.joker_char10 ?? '',
        joker_date1: el.joker_date1,
        joker_date2: el.joker_date2,
        joker_date3: el.joker_date3,
        joker_date4: el.joker_date4,
        joker_date5: el.joker_date5,
        joker_num1: el.joker_num1 ?? '',
        joker_num2: el.joker_num2 ?? '',
        joker_num3: el.joker_num3 ?? '',
        joker_num4: el.joker_num4 ?? '',
        joker_num5: el.joker_num5 ?? '',
        joker_num6: el.joker_num6 ?? '',
        joker_num7: el.joker_num7 ?? '',
        joker_num8: el.joker_num8 ?? '',
        joker_num9: el.joker_num9 ?? '',
        joker_num10: el.joker_num10 ?? '',
        joker_num11: el.joker_num11 ?? '',
        joker_num12: el.joker_num12 ?? '',
        joker_num13: el.joker_num13 ?? '',
        joker_num14: el.joker_num14 ?? '',
        joker_num15: el.joker_num15 ?? '',
        joker_int1: el.joker_int1 ?? '',
        joker_int2: el.joker_int2 ?? '',
        joker_int3: el.joker_int3 ?? '',
        joker_int4: el.joker_int4 ?? '',
        joker_int5: el.joker_int5 ?? '',
        description: el.description,
      })),
    });
  };

  const handleSubmit = (values) => {
    if (!editButtonVisible) {
      updateObject(values);
    } else if (!addField) {
      checkConsistency(values);
    }
  };

  const updateObject = async (values) => {
    const updData = {
      ...cleanValues(values),
      updatedBy: user.userId,
      costPerHour: parseFloat(values.costPerHour),
      employeeLine: values.employeeLine.map((employee) => cleanValues(employee)),
    };

    employeeService.updateEmployee(updData).then((data) => {
      addNotification({
        content: 'Sikeres módosítás!',
        type: NotificationType.SUCCESS,
      });

      setSelectedValues(data);
      setRefetchTable(true);
      setEditButtonvisible(true);
      setViewField(true);

      if (dialog) {
        dialog.setTaskChanged(true);
        dialog.handleClose();
      }
    });
  };

  //rögzítéskor lefut egy ellenőrzés, találat esetén visszatér, és egy dialog nyílik az egyező mezőkkel.
  //azért van szükség erre a függvényre, mert paraméterben szabályozható, hogy találatok esetén engedélyezett-e a rögzítés, vagy nem.

  const checkConsistency = (values) => {
    employeeService
      .checkConsistency(values)
      .then((data) => {
        if (data.fields.length === 0) {
          handleInsertObject(values);
        } else {
          setConfirmDialogOpen(true);
          setMatchedData({ ...data, values });
        }
      })
      .finally(() => {
        //@TODO loader
      });
  };

  const handleInsertObject = async (values) => {
    const insertObject = {
      ...cleanValues(values),
      createdBy: user.userId,
      costPerHour: parseFloat(values.costPerHour),
      employeeLine: values.employeeLine.map((employee) => cleanValues(employee)),
    };

    employeeService
      .createEmployee(insertObject)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });

        setSelectedValues(data);

        setRefetchTable(true);
        setAddField(true);
        setViewField(true);
        setConfirmDialogOpen(false);

        if (dialog) {
          dialog.setTaskChanged(true);
          dialog.handleClose();
        }
      })
      .finally(() => {
        //@TODO loader
      });
  };

  dayjs.extend(utc);

  const handleRemoveElement = async () => {
    const deleteData = {
      deletedBy: user.userId,
    };
    employeeService.deleteEmployee(deleteData, selectedValues.id).then(() => {
      addNotification({
        content: 'Sikeres törlés!',
        type: NotificationType.WARNING,
      });
      setRefetchTable(true);
      setShowDeleteDialog(false);
      setSelectedValues(defaultSelectedValues);

      if (dialog) {
        dialog.setTaskChanged(true);
        dialog.handleClose();
      }
    });
  };

  const handleTemplate = () => {
    employeeService.getExcelTemplate().then(() => {
      addNotification({
        content: 'A letöltés elindult!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const handleExport = () => {
    employeeService.getExcelData().then(() => {
      addNotification({
        content: 'A letöltés elindult!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const handleImport = (files) => {
    employeeService.importExcel(files, user.userId).then(() => {
      setRefetchTable(true);
      addNotification({
        content: 'Az import sikeres!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const onAddClick = () => {
    setSelectedValues(defaultSelectedValues);
    setViewField(false);
    setAddField(false);
  };

  return (
    <>
      <div className="h-full overflow-auto custom-scrollbar">
        <div className="flex items-center flex-wrap justify-between">
          <FormHeaderUI
            addClick={!dialog ? onAddClick : null}
            addDisabled={!viewField || !canEdit}
            modClick={() => {
              getEmployeeById(selectedValues.id);
              setViewField(false);
              setEditButtonvisible(false);
            }}
            modDisabled={!viewField || operatorsDisabled || !canEdit}
            deleteClick={() => {
              setShowDeleteDialog(true);
            }}
            deleteDisabled={!viewField || operatorsDisabled || !canEdit}
            copyClick={() => {
              setViewField(false);
              setAddField(false);
            }}
            copyDisabled={!viewField || operatorsDisabled || !canEdit}
          />
          <div>
            <History disabled={operatorsDisabled} onClick={() => setHistoryDialogOpen(!historyDialogOpen)} />
          </div>
        </div>

        <Formik
          initialValues={initValues}
          validationSchema={validationSchema}
          validateOnChange={false}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ setFieldValue, resetForm }) => (
            <Form>
              <EmployeeFields
                viewField={viewField}
                submenuId={submenu}
                selectedValues={selectedValues}
                autocompleteOptions={autocompleteOptions}
                setPriceDialogOpen={setPriceDialogOpen}
                addField={addField}
              />
              {!jokerLoading && (
                <EmployeeTabs
                  disabled={viewField}
                  submenuId={submenu}
                  setFieldValue={setFieldValue}
                  selectedValues={selectedValues}
                  setDefaultValues={setDefaultValues}
                  dynProperties={{ dynProps, setDynProps }}
                  user={user}
                  setRefetchTable={setRefetchTable}
                  handleImport={handleImport}
                  handleExport={handleExport}
                  handleTemplate={handleTemplate}
                  propertyGroups={propertyGroups}
                  groupState={{ group, setGroup }}
                  defaultField={defaultCommunication}
                  dynLoadingState={{ dynLoading, setDynLoading }}
                  setSelectedValues={setSelectedValues}
                  jokerFields={jokerFields}
                  defEmployeeLine={defEmployeeLine}
                  jokerLineFields={jokerLineFields}
                />
              )}

              <FormButtonPanelUI
                onCancelClick={() => {
                  setViewField(true);
                  setEditButtonvisible(true);
                  setAddField(true);

                  resetForm();
                }}
                disabled={editButtonVisible && addField}
              />
            </Form>
          )}
        </Formik>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
      />
      <HistoryDialog
        open={historyDialogOpen}
        handleClose={() => {
          setHistoryDialogOpen(false);
        }}
        formId={submenu}
        lineId={selectedValues.id}
        fieldConfig={[
          { field: 'employeeCommunication', objKey: 'message' },
          { field: 'dynamicProperties', objKey: 'textVal' },
        ]}
      />

      <ConfirmDialogUI
        show={confirmDialogOpen}
        onHide={() => setConfirmDialogOpen(false)}
        showConfirmButton={matchedData.recordable}
        handleChangeElement={() => handleInsertObject(matchedData.values)}
        title={matchedData.recordable ? 'Egyezési találat! Megerősíti a műveletet?' : 'Egyezési találat!'}
        message={
          matchedData.fields &&
          matchedData.fields.map((match) => (
            <p>
              {match.fieldName}: {match.value}
            </p>
          ))
        }
      />

      <EmployeePriceDialog
        open={priceDialogOpen}
        onClose={() => setPriceDialogOpen(false)}
        values={{ selectedValues, setSelectedValues }}
        setRefetchTable={setRefetchTable}
      />
    </>
  );
};
